import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "subscriptions.activationRate.title",
    defaultMessage: "Thank you for choosing Ring Twice+!",
  },
  quarterly: {
    id: "subscriptions.RT_quarterly",
    defaultMessage: "Quarterly",
  },
  yearly: {
    id: "subscriptions.RT_yearly",
    defaultMessage: "Yearly",
  },
  planTitleQuarterly: {
    id: "subscriptions.activationRate.planTitleQuarterly",
    defaultMessage: "Ring Twice+ Quarterly",
  },
  planTitleYearly: {
    id: "subscriptions.activationRate.planTitleYearly",
    defaultMessage: "Ring Twice+ Yearly",
  },
  includedOnSubscription: {
    id: "subscriptions.activationRate.includedOnSubscription",
    defaultMessage: "Included on your subscription:",
  },
  jobInsurance: {
    id: "subscriptions.activationRate.jobInsurance",
    defaultMessage: "Job insurance by AG",
  },
  noServiceFee: {
    id: "subscriptions.activationRate.noServiceFee",
    defaultMessage: "<bold>No service fee</bold> on every demand you do",
  },
  satisfiedOrRedone: {
    id: "subscriptions.activationRate.satisfiedOrRedone",
    defaultMessage: "Satisfied or redone",
  },
  cancelForFree: {
    id: "subscriptions.activationRate.cancelForFree",
    defaultMessage: "Something came up? Cancel the service for free",
  },
  total: {
    id: "orderDescription.total",
    defaultMessage: "Total",
  },
  cancelRenewal: {
    id: "subscriptions.activationRate.cancelRenewal",
    defaultMessage: "Cancel your subscription renewal at any time",
  },
  helpLink: {
    id: "subscriptions.activationRate.helpLink",
    defaultMessage: "Do you have a question? We are here to help!",
  },
  continueToPayment: {
    id: "subscriptions.activationRate.continueToPayment",
    defaultMessage: "Continue to payment",
  },
});
